import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-safarilink',
  templateUrl: './safarilink.component.html',
  styleUrls: ['./safarilink.component.scss']
})
export class SafarilinkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    const url = 'https://passes.23byt.es/passes/apple/apple_ds_20231107113030.pkpass';

    // Check if the user is on an iOS device
   // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    
      // If not on iOS, fallback to using window.open with _system
      window.open(url, '_system');
    // }
  }

}
